var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 400",
    style: {
      enableBackground: "new 0 0 1366 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.8,33.3L401,366.1h-98.1l-53.1-219l-55,219H96.7L12.4,33.3h86.7L147,275.5l59.2-242.2h89.1l56.9,242.2l48.3-242.2 H487.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.6,307.3H611.5l-19.9,58.8h-84.8L627.1,33.3h93.8l120.4,332.7h-85.8L735.6,307.3z M714.8,244.7l-41.2-121.8 l-40.8,121.8H714.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.8,357.5c-19.3-7.9-34.7-19.6-46.2-35.1c-11.5-15.5-17.6-34.1-18.2-55.9h86.3c1.3,12.3,5.5,21.7,12.8,28.2 c7.3,6.5,16.7,9.7,28.4,9.7c12,0,21.5-2.8,28.4-8.3c6.9-5.5,10.4-13.2,10.4-23c0-8.2-2.8-15-8.3-20.4c-5.5-5.4-12.3-9.8-20.4-13.3 c-8.1-3.5-19.5-7.4-34.4-11.8c-21.5-6.6-39-13.3-52.6-19.9c-13.6-6.6-25.3-16.4-35.1-29.4c-9.8-13-14.7-29.9-14.7-50.7 c0-31,11.2-55.2,33.7-72.8c22.4-17.5,51.7-26.3,87.7-26.3c36.7,0,66.2,8.8,88.6,26.3c22.4,17.5,34.4,41.9,36,73.2h-87.7 c-0.6-10.7-4.6-19.2-11.8-25.4c-7.3-6.2-16.6-9.2-28-9.2c-9.8,0-17.7,2.6-23.7,7.8c-6,5.2-9,12.7-9,22.5c0,10.7,5.1,19.1,15.2,25.1 c10.1,6,25.9,12.5,47.4,19.4c21.5,7.3,38.9,14.2,52.4,20.9c13.4,6.6,25,16.3,34.8,28.9c9.8,12.6,14.7,28.9,14.7,48.8 c0,19-4.8,36.2-14.5,51.7c-9.6,15.5-23.6,27.8-41.9,37c-18.3,9.2-40,13.7-64.9,13.7C973.9,369.4,952.1,365.4,932.8,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.4,303.5h106.2v62.6h-187.2V33.3h81V303.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasl);
export default __webpack_public_path__ + "static/media/wasl.9b2a22f2bf0d8e9b3f81c9b5533937fc.svg";
export { ForwardRef as ReactComponent };